import { render, staticRenderFns } from "./RollUserBetsElement.vue?vue&type=template&id=3db89126&scoped=true"
import script from "./RollUserBetsElement.vue?vue&type=script&lang=js"
export * from "./RollUserBetsElement.vue?vue&type=script&lang=js"
import style0 from "./RollUserBetsElement.vue?vue&type=style&index=0&id=3db89126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db89126",
  null
  
)

export default component.exports